function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Organization",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Contractor-detail-view",
  transform: "translate(-551.000000, -496.000000)",
  fill: "#E3E5EF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(260.000000, 224.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M299.5,272 C294.805601,272 291,275.805567 291,280.5 C291,285.194433 294.805601,289 299.5,289 C304.194399,289 308,285.194399 308,280.5 C308,275.805601 304.194433,272 299.5,272 Z M303.959347,276.040653 C306.202524,278.283831 306.35854,281.712381 304.668034,284.116921 L295.883044,275.332 C298.28923,273.640363 301.717403,273.798744 303.959347,276.040653 Z M295.040653,284.959347 C292.797476,282.716169 292.64146,279.287619 294.331966,276.883079 L303.116956,285.668 C300.710804,287.359637 297.282597,287.20129 295.040653,284.959347 Z",
  id: "Shape"
}))));

function SvgBanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Do not hire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanIcon);
export default __webpack_public_path__ + "static/media/ban-icon.677e4c0b.svg";
export { ForwardRef as ReactComponent };